<div class="politicas-entrega-filtros">
  <div class="politicas-filtro-selects">
    <div class="politicas-filtro-region">
      <app-cbb-select
        label="Región"
        [options]="store.regiones()"
        bindLabel="nombre"
        [clearable]="true"
        [ngModel]="store.regionSeleccionada()"
        (ngModelChange)="onRegionSeleccionadaChange($event)"
        [mensajeError]="regionBuscarError"
        placeholder="Seleccione región"
      >
      </app-cbb-select>
    </div>
    <div class="politicas-filtro-incoterms">
      <app-cbb-select
        label="Incoterms"
        [options]="incotermsItems"
        [clearable]="true"
        [searchable]="false"
        [ngModel]="store.incotermsSeleccionado()"
        (ngModelChange)="store.setIncotermsSeleccionado($event)"
        placeholder="Incoterms"
      >
      </app-cbb-select>
    </div>
  </div>
  <div class="politicas-filtro-acciones">
    <app-cbb-button
      label="Carga masiva"
      color="info"
      (action)="abrirModalCargaMasiva()"
      [disabled]="store.loading()"
    ></app-cbb-button>
    <app-cbb-button
      label="Buscar"
      color="green"
      (action)="buscar()"
      [disabled]="store.loading()"
    ></app-cbb-button>
  </div>
</div>
<div *ngIf="store.error()" class="alert alert-warning py-2" role="alert">{{ store.error() }}</div>

<div *ngIf="store.rows().length > 0" class="small text-muted mb-2">
  Filas cargadas: {{ store.rows().length }}. Primera comuna: {{ store.rows()[0].comuna }}.
</div>

<app-cemento-admin-matrix-table
  [rows]="store.rows()"
  (cellSelected)="abrirDetalle($event)"
></app-cemento-admin-matrix-table>

<p *ngIf="!store.loading() && store.rows().length === 0" class="text-muted small mt-2 mb-0">
  No hay filas para mostrar con la combinación actual.
</p>

<ng-template #detalleTpl>
  <app-politica-entrega-detalle-modal
    [cell]="selectedCell"
    [incoterms]="store.incotermActivo()"
    [loading]="store.loading()"
    (closeRequested)="cerrarDetalleModal()"
    (saveRequested)="guardarDetalle($event)"
    (deleteRequested)="solicitarEliminarDetalle()"
  ></app-politica-entrega-detalle-modal>
</ng-template>

<ng-template #cargaMasivaTpl>
  <app-politicas-entrega-carga-masiva-modal
    (closeRequested)="cerrarCargaMasivaModal()"
    (uploadRequested)="subirExcel($event)"
  ></app-politicas-entrega-carga-masiva-modal>
</ng-template>

<ng-template #confirmDeleteTpl>
  <app-politicas-entrega-confirm-delete-modal
    [loading]="store.loading()"
    (closeRequested)="cancelarEliminarDetalle()"
    (confirmRequested)="confirmarEliminarDetalle()"
  ></app-politicas-entrega-confirm-delete-modal>
</ng-template>
